import { z } from "zod";

export const SalesReportFilterSchemaV4 = z.object({
    property_id: z.string(),
    base_on: z.enum(["stay_date", "created_reservation", "checkin_date", "checkout_date"]),
    start_date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
    end_date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
});

export type SalesReportFilterV4Type = z.infer<typeof SalesReportFilterSchemaV4>;